import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import Page from '@src/components/page';
import PageLayout from '@src/business-components/page-layout';

import AuditionAudioStore from './store';

import aos from '@src/utils/aos';

import Link from '@src/components/link';
import BaseSwiper from '@src/components/swiper/base-swiper';
const styles = require('./index.less');

const AuditionAudio = () => {
  const store = useStore(() => new AuditionAudioStore());

  return (
    <Page className={styles.mediaImageRoot}>
      <PageLayout store={store.pageLayoutStore} title={<span className={styles.title} />}>
        <div className={styles.content} {...aos.FADE_UP()}>
          {store.imageList?.length > 0 && (
            <div className={styles.currentImageWrapper}>
              <BaseSwiper store={store.bigImageSwiperStore}>
                {store.imageList.map((item, index) => (
                  <div className={styles.bigImage} key={index}>
                    <img src={item.cover} alt={item.title} className={styles.bigImage} />
                  </div>
                ))}
              </BaseSwiper>
            </div>
          )}
          <div className={styles.imageList}>
            {store.imageList?.length > 0 && (
              <div className={styles.smallImageWrapper}>
                <Link className={styles.prevBtn} onClick={() => store.smallImageSwiperStore.goPrev()} />
                <div className={styles.smallImageSwiper}>
                  <BaseSwiper store={store.smallImageSwiperStore}>
                    {store.imageList.map((item, index) => (
                      <div
                        className={styles.smallImage}
                        key={index}
                        onClick={() => {
                          store.currentImageIndex = index;
                        }}
                      >
                        <div className="smallImageInner" style={{ backgroundImage: `url(${item.thumbImg})` }} />
                      </div>
                    ))}
                  </BaseSwiper>
                </div>
                <Link className={styles.nextBtn} onClick={() => store.smallImageSwiperStore.goNext()} />
              </div>
            )}
          </div>
        </div>
      </PageLayout>
    </Page>
  );
};

export default observer(AuditionAudio);
